import { render, staticRenderFns } from "./PessoaJuridica.vue?vue&type=template&id=c390aa94"
import script from "./PessoaJuridica.vue?vue&type=script&lang=js"
export * from "./PessoaJuridica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports